import React from "react";
import Header from "./Header";
import Logo from "./nabeel.JPG";

const About = () => {
    
    return(
        <>
        <Header></Header>
        <section className="about-me" id="about">
        <br />
        <h2>About Me</h2>
        <h3>My introduction</h3>
        <div className="about-content">
            <img src={Logo} alt="Profile" class="about-image" />
            <div className="about-text">
                <div className="status">
                    <div className="status-item">Fresher<br /><h4>Looking for my new opportunity</h4></div>
                    <div className="status-item">Completed<br /><h4>5+ Projects</h4></div>
                    <div className="status-item">Support<br /><h4>Online 24/7</h4></div>
                </div>
                <div className="para">
                    <ul>
                    <li> A Recent college graduate seeking an entry-level position in the field of Web Design. Possesses a strong academic record, having graduated with honors, eager to put my skills to work in a professional setting.</li>
                    <li> A highly creative Web Designer with an UI / UX. Proven skills in HTML, CSS, and React. Ability to work independently and collaborate effectively with a team.</li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
    </>
    )
}
export default About;